import ApiService from './api'

export default {
  getWeatherData() {
    return ApiService.get(`/weather`)
  },
}
